import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { OrganizationType } from '@/bundle/_Opco/types/types';
import { OrgAdminRoleType } from '@/const/user';
import { SubscriptionPlanType } from '@/const/shared';

export type CreateOrganizationPayloadType = {
  organization: {
    name: string;
    subscription_plan_type: SubscriptionPlanType;
    is_kyc_allowed: boolean;
    is_api_keys_allowed: boolean;
  };
  user: {
    email: string;
    mobile_phone: string;
    first_name: string;
    middle_name?: string;
    last_name: string;
    role: OrgAdminRoleType;
  };
};

export const createOrganizationApi = (
  data: CreateOrganizationPayloadType,
  options?: RequestOptions
): Promise<ApiResponseType<OrganizationType>> => {
  const uri = '/opco/organizations/';

  return authApiService.POST(uri, data, null, options);
};
